import { Text } from '@lana-ui/common';
import { Button } from '@lana-ui/login';
import Beneficios from '../../Features/Beneficios';
import PlanAnual from '../../Features/PlanAnual';
import PlanCheckout from '../../Features/PlanCheckout';
import { EventTrackAndLogData } from '../../../Config/TrackAndLogData';
import DrawerAccordion from '../login/src/drawerAccordion/DrawerAccordion.jsx';

const Suscripcion = ({
    isPlanAnual,
    conClub,
    precioTotal,
    cambiarPlanOnClick,
    mesProporcional,
    mesProporcionalPrecio,
    mesSuscripcion,
    mesSuscripcionPrecio,
    mesesDescuento,
    precioFinal,
    features,
    state,
    isConfirmacion,
    openedDrawer,
}) => {
    const datosPlan = state.context.planCampania?.planes[0];
    const sendPartialInputsToAnalytics = () => {
        const datosPersonales = state.context.datosPersonales;
        const erroresDatosPersonales = state.context.erroresDatosPersonales;
        const camposATrackear = ['nombre', 'apellido', 'numeroDocumento', 'telefonoCelular', 'terminos'];

        for (const clave in datosPersonales) {
            if (camposATrackear.includes(clave)) {
                if (datosPersonales[clave] == '') {
                    EventTrackAndLogData('cambiar-plan', { emptyFields: clave });
                } else if (erroresDatosPersonales.hasOwnProperty(clave)) {
                    EventTrackAndLogData('cambiar-plan', { errorFields: clave });
                }
            }
        }
    };

    return (
        <DrawerAccordion
            title={isConfirmacion ? 'VER MIS BENEFICIOS:' : 'ESTÁS ELIGIENDO EL PLAN:'}
            subtitle={
                conClub ? (
                    <>Acceso Digital + Club LA NACION: {!isConfirmacion ? ` $${precioTotal}` : ''}</>
                ) : (
                    <>
                        Acceso Digital{isPlanAnual && ` ANUAL`}
                        {!isConfirmacion ? `: $${precioTotal}` : ''}
                    </>
                )
            }
            backgroundColor="gray"
            headerElementsDistance="large"
            titleBold={true}
            isConfirmacion={isConfirmacion}
            openedDrawer={openedDrawer}
        >
            <>
                <Beneficios features={features} />

                {!isConfirmacion && (
                    <>
                        {isPlanAnual ? (
                            <PlanAnual precioTotal={precioTotal} />
                        ) : (
                            <>
                                <PlanCheckout
                                    mesProporcional={mesProporcional}
                                    mesProporcionalPrecio={mesProporcionalPrecio}
                                    mesSuscripcion={mesSuscripcion}
                                    mesSuscripcionPrecio={mesSuscripcionPrecio}
                                    precioLuegoDeTiempo={precioFinal}
                                    mesesDescuento={mesesDescuento}
                                    datosPlan={datosPlan}
                                />
                                <Text as="p" size="6xs" className="--mb-16">
                                    El pago de la suscripción se realiza por mes adelantado. Si compraste hasta el día 2, abonás el proporcional de días restantes del mes en curso. Si realizaste la{' '}
                                    compra a partir del día 3, abonás el proporcional de días restantes y el mes próximo.
                                </Text>
                            </>
                        )}

                        <div className="cambiar-plan-button">
                            <Button
                                type="button"
                                className="--not-disabled cambiar-plan"
                                label="Elegir otro plan"
                                onClick={() => {
                                    sendPartialInputsToAnalytics();
                                    cambiarPlanOnClick();
                                }}
                            />
                        </div>
                    </>
                )}
                <br />
            </>
        </DrawerAccordion>
    );
};

export default Suscripcion;
